import React from "react";

var pinOutlineSvg = function pinOutlineSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M8.719 11l-.349 4.625c0 .196-.15.356-.34.373L7.994 16a.375.375 0 0 1-.367-.3L7.28 11zm1.35-11a1 1 0 0 1 .997.929L11.5 7h.5a1 1 0 0 1 1 1v1H3V8a1 1 0 0 1 1-1h.5L4.934.929A1 1 0 0 1 5.93 0zm-.932 1.999H6.862L6.504 7h2.991z"
  }));
};

pinOutlineSvg.defaultProps = {
  height: "16",
  viewBox: "0 0 16 16",
  width: "16",
  xmlns: "http://www.w3.org/2000/svg"
};
export var pinOutline = {
  category: 'icon',
  colorable: true,
  name: 'pinOutline',
  svg: pinOutlineSvg
};